import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargePricingDetailScreen from './screens/ChargePricingDetailScreen';
import ChargePricingListScreen from './screens/ChargePricingListScreen';

ChargePricing.propTypes = {};

function ChargePricing(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<ChargePricingListScreen />} />
          <Route path=":chargePricingId" element={<ChargePricingDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ChargePricing;
